'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var System$Genetics = require("./System.bs.js");

function MakeMappedSystem(S, M) {
  var include = System$Genetics.ExtendSystem(S);
  var toDNA = include.toDNA;
  var toRNA = include.toRNA;
  var replicate = include.replicate;
  var transcribe = include.transcribe;
  var reverse_transcribe = include.reverse_transcribe;
  var to_string = include.to_string;
  var map = M.map;
  var toDNA$1 = function (bases) {
    return Curry._2(map, toDNA, bases);
  };
  var toRNA$1 = function (bases) {
    return Curry._2(map, toRNA, bases);
  };
  var replicate$1 = function (bases) {
    return Curry._2(map, replicate, bases);
  };
  var transcribe$1 = function (bases) {
    return Curry._2(map, transcribe, bases);
  };
  var reverse_transcribe$1 = function (bases) {
    return Curry._2(map, reverse_transcribe, bases);
  };
  var to_string$1 = function (bases) {
    return Curry._2(map, to_string, bases);
  };
  return {
          complementD: include.complementD,
          complementR: include.complementR,
          base_to_string: include.base_to_string,
          from_string: include.from_string,
          map: map,
          toDNA: toDNA$1,
          toRNA: toRNA$1,
          replicate: replicate$1,
          transcribe: transcribe$1,
          reverse_transcribe: reverse_transcribe$1,
          to_string: to_string$1
        };
}

function map(f, param) {
  if (param !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(param)));
  }
  
}

var OptionMap = {
  map: map
};

function map$1(f) {
  return (function (param) {
      return $$Array.map((function (param) {
                    return map(f, param);
                  }), param);
    });
}

var ArrayOptions = {
  map: map$1
};

var partial_arg = System$Genetics.Standard;

var Poly = (function (param) {
      var include = System$Genetics.ExtendSystem(partial_arg);
      var toDNA = include.toDNA;
      var toRNA = include.toRNA;
      var replicate = include.replicate;
      var transcribe = include.transcribe;
      var reverse_transcribe = include.reverse_transcribe;
      var to_string = include.to_string;
      var map = param.map;
      var toDNA$1 = function (bases) {
        return Curry._2(map, toDNA, bases);
      };
      var toRNA$1 = function (bases) {
        return Curry._2(map, toRNA, bases);
      };
      var replicate$1 = function (bases) {
        return Curry._2(map, replicate, bases);
      };
      var transcribe$1 = function (bases) {
        return Curry._2(map, transcribe, bases);
      };
      var reverse_transcribe$1 = function (bases) {
        return Curry._2(map, reverse_transcribe, bases);
      };
      var to_string$1 = function (bases) {
        return Curry._2(map, to_string, bases);
      };
      return {
              complementD: include.complementD,
              complementR: include.complementR,
              base_to_string: include.base_to_string,
              from_string: include.from_string,
              map: map,
              toDNA: toDNA$1,
              toRNA: toRNA$1,
              replicate: replicate$1,
              transcribe: transcribe$1,
              reverse_transcribe: reverse_transcribe$1,
              to_string: to_string$1
            };
    })(ArrayOptions);

exports.MakeMappedSystem = MakeMappedSystem;
exports.OptionMap = OptionMap;
exports.ArrayOptions = ArrayOptions;
exports.Poly = Poly;
/* Poly Not a pure module */
